

import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class Meetingtype extends EntityDto implements IEntityDto {
  MeetingType_Id: string;
  MeetingTypeName: string;
  MeetingTypeAccess:string;
  DisplayText:string;
  Response_MeetingType_Id: string;
  MeetingtypeDescription: string;
  Code:string;
 
  IsActive: boolean;
  Emp_Ref_Id: string;
  EmployeeName: string;
  TotalCount: number;

  constructor() {
    super();
    this.MeetingType_Id = '00000000-0000-0000-0000-000000000000';
    this.Response_MeetingType_Id='00000000-0000-0000-0000-000000000000';
    this.MeetingtypeDescription = '';
    this.MeetingTypeName = '';
    this.MeetingTypeAccess='';
    this.DisplayText='';
    this.Code="";
   
   
    this.Emp_Ref_Id = '';
    this.EmployeeName = '';
    this.TotalCount = 0;
    this.IsActive = true;

    this.EntityMetaData = [
    
   //   { FieldName: 'MeetingType_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting type Id  is required' },
     { FieldName: 'MeetingTypeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Group Name is required' },
     { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
     { FieldName: 'MeetingTypeAccess', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meeting Type Access is required' },
  
     //{ FieldName: 'MeetingtypeDescription', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Meetingtype Description is required' },
    
    ];
  }
}